import { render, staticRenderFns } from "./SlotsGameCard.vue?vue&type=template&id=6fb32bbc&scoped=true"
import script from "./SlotsGameCard.vue?vue&type=script&lang=js"
export * from "./SlotsGameCard.vue?vue&type=script&lang=js"
import style0 from "./SlotsGameCard.vue?vue&type=style&index=0&id=6fb32bbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb32bbc",
  null
  
)

export default component.exports